import FlatTable, { flatValue } from "../../../common/FlatTable/FlatTable";

import "./flatStyles.scss";

const MAX_PLUGIN_ROWS = 40;

const dateColumn = { label: "Date", render: (row) => flatValue(row?.date) };
// Plain text on purpose: the interactive cell renderer paints the method
// yellow, which is invisible on the pdf's white page.
const methodColumn = { label: "Method", render: (row) => flatValue(row?.method) };
const nameColumn = { label: "Name", render: (row) => flatValue(row?.name) };

const GROUPS = [
  { key: "Library", title: "Library", columns: [dateColumn, nameColumn] },
  { key: "DeletedFiles", title: "Deleted Files", columns: [dateColumn, methodColumn, nameColumn] },
  { key: "File", title: "Files", columns: [dateColumn, methodColumn, nameColumn] },
  {
    key: "SharedPreferences",
    title: "Shared Preferences",
    columns: [
      dateColumn,
      methodColumn,
      { label: "File Path", render: (row) => flatValue(row?.file_path) },
      { label: "Value", render: (row) => flatValue(row?.value) },
    ],
  },
];

// Stateless counterpart of AndroidPlugins.js, which is a four tab switcher:
// only the active tab is mounted there, so a capture would hold one table.
// This stacks all four.
const AndroidPluginsFlat = ({ plugins }) => {
  const groups = GROUPS.map((group) => ({
    ...group,
    rows: Array.isArray(plugins?.[group.key]) ? plugins[group.key] : [],
  })).filter((group) => group.rows.length > 0);

  if (groups.length === 0) {
    return (
      <div className="android-plugins-flat">
        <p className="android-plugins-flat__empty">No plugin data found</p>
      </div>
    );
  }

  return (
    <div className="android-plugins-flat">
      {groups.map((group) => (
        <div className="android-plugins-flat__group" key={group.key}>
          <h3 className="android-plugins-flat__group-title">{group.title}</h3>
          <FlatTable
            columns={group.columns}
            data={group.rows}
            maxRows={MAX_PLUGIN_ROWS}
            moreLabel="rows"
          />
        </div>
      ))}
    </div>
  );
};

export default AndroidPluginsFlat;
